export default "__VITE_ASSET__DqWl3Ajj__"